var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint0_linear_4807_720)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.673 28.3478C24.9107 28.3478 28.3461 24.9121 28.3461 20.6739C28.3461 16.4357 24.9107 13 20.673 13C16.4353 13 13 16.4357 13 20.6739C13 24.9121 16.4353 28.3478 20.673 28.3478Z",
    stroke: "white",
    strokeWidth: 1.91848
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8154 27.2949L32.9199 33.3995",
    stroke: "white",
    strokeWidth: 1.91848,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4807_720",
    x1: 0,
    y1: 24,
    x2: 48,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E93333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A2066"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqButton);
export default __webpack_public_path__ + "static/media/faqButton.259de91026859f772093c1e342ad41e1.svg";
export { ForwardRef as ReactComponent };